module.exports = __webpack_public_path__ + "img/t-shirt.74d6cd4b.png";